(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.body.dataset.root || '/';
  const strings = JSON.parse(document.querySelector('#cl-strings')?.textContent || '{}');
  const currency = document.body.dataset.currency || 'EUR';
  const locale = document.body.dataset.locale || 'ca';
  const money = value => new Intl.NumberFormat(locale, {style:'currency', currency}).format(value / 100);
  const toast = document.querySelector('.cl-toast');
  let toastTimer;
  function inform(message) {
    if (!toast) return;
    toast.querySelector('[data-toast-text]').textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {toast.hidden = true;}, 8000);
  }
  const photoRequests = new WeakMap();
  async function revealPhoto(picture,url) {
    if(!picture||!url) return;
    const request=(photoRequests.get(picture)||0)+1;photoRequests.set(picture,request);
    const incoming=new Image();incoming.src=url;
    try {await incoming.decode();} catch {return;}
    if(photoRequests.get(picture)!==request) return;
    const previous=picture.cloneNode();previous.removeAttribute('id');previous.removeAttribute('srcset');previous.src=picture.currentSrc||picture.src;previous.className='cl-photo-previous';previous.alt='';previous.setAttribute('aria-hidden','true');
    picture.src=url;picture.removeAttribute('srcset');
    if(reduced.matches) return;
    picture.parentElement.append(previous);
    picture.animate([{transform:'scale(1.025)'},{transform:'scale(1)'}],{duration:520,easing:'cubic-bezier(.16,1,.3,1)'});
    previous.animate([{clipPath:'inset(0 0 0 0)'},{clipPath:'inset(0 100% 0 0)'}],{duration:440,easing:'cubic-bezier(.16,1,.3,1)'}).finished.finally(()=>previous.remove());
  }
  function markPhoto(controls,url) {
    controls?.querySelectorAll('[data-photo-url]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.photoUrl===url)));
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-community]:not([data-initialized])').forEach(community=>{
      community.dataset.initialized='true';
      const rail=community.querySelector('[data-community-rail]'),items=[...rail.children];
      const previous=community.querySelector('[data-community-prev]'),next=community.querySelector('[data-community-next]');
      const position=community.querySelector('[data-community-position]');
      community.querySelector('[data-community-tools]').hidden=false;
      function update(){
        const gap=parseFloat(getComputedStyle(rail).columnGap)||0,step=items[0].getBoundingClientRect().width+gap;
        const first=Math.min(items.length,Math.round(rail.scrollLeft/step)+1),visible=Math.max(1,Math.floor((rail.clientWidth+gap)/step));
        const last=Math.min(items.length,first+visible-1);position.textContent=`${first===last?first:`${first}–${last}`} / ${items.length}`;
        previous.disabled=rail.scrollLeft<2;next.disabled=rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-2;
      }
      function move(direction){const step=items[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(rail).columnGap)||0);rail.scrollBy({left:direction*step,behavior:reduced.matches?'instant':'smooth'});}
      previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
      rail.addEventListener('keydown',event=>{if(event.target!==rail)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
      let frame;rail.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);},{passive:true});
      new ResizeObserver(update).observe(rail);update();
      const dialog=community.querySelector('[data-community-dialog]');let trigger;
      community.querySelectorAll('[data-community-photo]').forEach(link=>link.addEventListener('click',event=>{
        if(!dialog?.showModal)return;event.preventDefault();trigger=link;
        const image=dialog.querySelector('[data-community-enlarged]');image.src=link.href;image.alt=link.querySelector('img').alt;
        dialog.querySelector('[data-community-caption]').textContent=link.closest('.cl-community-item').querySelector('[data-community-author]').textContent;
        dialog.showModal();dialog.querySelector('[data-community-close]').focus();
      }));
      dialog.querySelector('[data-community-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>trigger?.focus());
    });
    scope.querySelectorAll('.cl-card:not([data-photo-ready])').forEach(card=>{
      card.dataset.photoReady='true';const controls=card.querySelector('[data-photo-switch]');if(!controls)return;
      controls.hidden=false;
      controls.addEventListener('click',event=>{const button=event.target.closest('[data-photo-url]');if(!button)return;markPhoto(controls,button.dataset.photoUrl);revealPhoto(card.querySelector('.cl-card-front'),button.dataset.photoUrl);});
    });
    scope.querySelectorAll('[data-campaign]:not([data-initialized])').forEach(campaign => {
      campaign.dataset.initialized = 'true';
      const inspect = campaign.querySelector('[data-inspect]');
      inspect?.addEventListener('click', () => {
        const on = inspect.getAttribute('aria-pressed') !== 'true';
        inspect.setAttribute('aria-pressed', String(on));
        campaign.classList.toggle('is-inspecting', on);
      });
      if (!reduced.matches) {
        campaign.querySelector('.cl-person')?.animate([{transform:'translateY(28px) rotate(-3deg)'},{transform:'translateY(0) rotate(0)'}],{duration:1100,easing:'cubic-bezier(.16,1,.3,1)'});
        campaign.querySelector('.cl-campaign-second')?.animate([{translate:'50px 35px',rotate:'5deg'},{translate:'0 0',rotate:'0deg'}],{duration:1400,easing:'cubic-bezier(.16,1,.3,1)'});
        const title = campaign.querySelector('.cl-campaign-type');
        const portrait = campaign.querySelector('.cl-campaign-person');
        const second = campaign.querySelector('.cl-campaign-second');
        let queued = false, active = true;
        
        const update = () => {
          queued = false;
          if (!active || reduced.matches) return;
          const progress = Math.min(1,Math.max(0,-campaign.getBoundingClientRect().top / campaign.offsetHeight));
          if (title) title.style.translate = `0 ${-progress * 58}px`;
          if (portrait) portrait.style.translate = `0 ${progress * 24}px`;
          if (second) second.style.translate = `0 ${-progress * 40}px`;
        };
        const schedule = () => {if (!queued) {queued=true;requestAnimationFrame(update);}};
        const observer = new IntersectionObserver(entries => {active=entries[0].isIntersecting;if(active) schedule();}, {threshold:0});
        observer.observe(campaign);
        window.addEventListener('scroll',schedule,{passive:true});
        window.addEventListener('resize',schedule,{passive:true});
        reduced.addEventListener('change',() => {if(reduced.matches) [title,portrait,second].forEach(el=>el?.style.removeProperty('translate'));else schedule();});
        schedule();
      }
    });
    scope.querySelectorAll('[data-product]:not([data-initialized])').forEach(product => {
      product.dataset.initialized = 'true';
      const form = product.querySelector('.cl-product-form');
      const select = form?.querySelector('[name=id]');
      const options = product.querySelector('.cl-options');
      const variants = JSON.parse(product.querySelector('[data-variants]')?.textContent || '[]');
      const add = product.querySelector('[data-add]');
      const message = product.querySelector('[data-form-message]');
      const picture = product.querySelector('[data-main-media]>img');
      const zoomDialog = product.querySelector('.cl-zoom-dialog');
      const sizeDialog = product.querySelector('.cl-size-dialog');
      const chartContent = sizeDialog?.querySelector('.cl-size-content');
      const chartSelect = sizeDialog?.querySelector('[data-size-chart]');
      const allTables=[...(chartContent?.querySelectorAll('table')||[])];
      const tables=allTables.filter(table=>table.rows[0]?.cells.length>=3&&table.rows[0].textContent.includes('Talla'));
      if (chartContent && chartSelect && tables.length === 5) {
        const diagram = chartContent.querySelector('img')?.cloneNode(true);
        const measurement=allTables.find(table=>!tables.includes(table))?.cloneNode(true);
        const note=sizeDialog.querySelector('[data-size-note]');
        const wrappers = tables.map((table,index) => {
          const wrapper = document.createElement('div');
          const title = document.createElement('p');title.className='cl-chart-caption';title.textContent=chartSelect.options[index].text;
          wrapper.append(title,table.cloneNode(true));return wrapper;
        });
        chartContent.replaceChildren(...wrappers);
        const instructions=document.createElement('details');instructions.className='cl-chart-instructions';
        const summary=document.createElement('summary');summary.textContent=chartContent.dataset.instructionsLabel;instructions.append(summary);
        if(note) instructions.append(note);
        if(measurement) instructions.append(measurement);
        if(diagram) {diagram.classList.add('cl-size-diagram');instructions.append(diagram);}
        chartContent.append(instructions);
        const fullGuide = product.querySelector('[data-open-size]').cloneNode(true);fullGuide.removeAttribute('data-open-size');fullGuide.textContent=chartContent.dataset.fullGuideLabel;chartContent.append(fullGuide);
        const identity = product.dataset.productKind;
        chartSelect.value = identity.includes('dessuador') ? '4' : identity.includes('infant') ? '3' : identity.includes('dona') ? '0' : '1';
        const showChart = () => wrappers.forEach((wrapper,index) => wrapper.hidden = index !== Number(chartSelect.value));
        chartSelect.addEventListener('change',showChart);chartSelect.closest('label').hidden=false;showChart();
      }
      let selected, adding = false;
      const anyAvailable = variants.some(variant => variant.available);
      const sticky = product.querySelector('[data-sticky-buy]');
      const stickyAdd = product.querySelector('[data-sticky-add]');
      function updateSticky() {
        if (!sticky) return;
        sticky.querySelector('[data-sticky-price]').textContent = product.querySelector('[data-price]').textContent;
        sticky.querySelector('[data-sticky-variant]').textContent = selected?.title || product.querySelector('h1').textContent;
        stickyAdd.textContent = adding ? strings.adding : selected ? (selected.available ? strings.add : strings.sold) : strings.choose;
        stickyAdd.disabled = adding || !anyAvailable || (selected && !selected.available);
      }
      if (sticky) {
        const buyRow = product.querySelector('.cl-buy-row');
        let stickyFrame;
        const placeSticky = () => {
          stickyFrame = undefined;
          sticky.hidden = buyRow.getBoundingClientRect().bottom >= 0;
        };
        const scheduleSticky = () => {
          if (!stickyFrame) stickyFrame = requestAnimationFrame(placeSticky);
        };
        window.addEventListener('scroll', scheduleSticky, {passive:true});
        window.addEventListener('resize', scheduleSticky, {passive:true});
        placeSticky();
        stickyAdd.addEventListener('click', () => {
          if (selected?.available) form.requestSubmit(add);
          else {
            options.scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'center'});
            options.querySelector('fieldset:not(:has(input:checked)) input:not(:disabled)')?.focus({preventScroll:true});
          }
        });
      }
      function chooseImage(url) {
        if (!picture || !url) return;
        revealPhoto(picture,url);
        markPhoto(product.querySelector('[data-photo-switch]'),url);
        zoomDialog?.querySelector('img').setAttribute('src',url);
      }
      const photoControls=product.querySelector('[data-photo-switch]');
      if(photoControls) {photoControls.hidden=false;photoControls.addEventListener('click',event=>{const button=event.target.closest('[data-photo-url]');if(button)chooseImage(button.dataset.photoUrl);});}
      product.querySelectorAll('[data-product-thumb]').forEach(thumb => thumb.addEventListener('click', event => {
        event.preventDefault();
        chooseImage(thumb.dataset.image);
        product.querySelectorAll('[data-product-thumb]').forEach(x => x.classList.toggle('is-selected',x === thumb));
      }));
      function selection() {
        const groups = [...options.querySelectorAll('fieldset')];
        const values = groups.map(group => group.querySelector('input:checked')?.value);
        selected = variants.find(variant => variant.options.every((value,index) => value === values[index]));
        select.value = selected ? selected.id : '';
        groups.forEach((group,index) => {
          group.querySelector('[data-chosen-option]').textContent = values[index] ? `— ${values[index]}` : '';
          group.querySelectorAll('input').forEach(input => {
            const exists = variants.some(variant => variant.available && variant.options[index] === input.value && values.every((value,position) => position === index || !value || variant.options[position] === value));
            input.disabled = !exists;
          });
        });
        add.disabled = adding || !anyAvailable || (selected ? !selected.available : false);
        add.firstChild.textContent = adding ? strings.adding : !anyAvailable ? strings.sold : selected ? (selected.available ? strings.add : strings.sold) : strings.choose;
        const accelerated = product.querySelector('.cl-express');
        if (accelerated) accelerated.hidden = !selected?.available;
        if (selected) {
          product.querySelector('[data-price]').textContent = money(selected.price);
          const compare = product.querySelector('[data-compare]');
          if (compare) {compare.hidden = !(selected.compare_at_price > selected.price);compare.textContent = compare.hidden ? '' : money(selected.compare_at_price);}
          if (selected.featured_image?.src) chooseImage(selected.featured_image.src);
          const url = new URL(location.href);url.searchParams.set('variant',selected.id);history.replaceState(null,'',url);
        }
        updateSticky();
      }
      if (form && select && options && variants.length) {
        options.hidden = false;
        product.querySelector('.cl-variant-fallback').hidden = true;
        select.required = false;
        options.addEventListener('change', () => {selection();message.textContent='';});
        selection();
        form.addEventListener('submit',async event => {
          event.preventDefault();
          if (adding) return;
          message.classList.remove('is-error');
          if (!selected?.available) {
            message.textContent = selected ? strings.sold : strings.choose;
            options.querySelector('fieldset:not(:has(input:checked)) input:not(:disabled)')?.focus();
            return;
          }
          if (!form.reportValidity()) return;
          adding = true;add.disabled = true;add.setAttribute('aria-busy','true');add.firstChild.textContent = strings.adding;updateSticky();
          try {
            const payload = new FormData(form);
            for (const key of [...payload.keys()]) if (key.startsWith('cl-option')) payload.delete(key);
            const response = await fetch(`${root}cart/add.js`,{method:'POST',body:payload,headers:{'Accept':'application/json'}});
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || strings.error);
            inform(strings.added);message.textContent = strings.added;
            const cartResponse = await fetch(`${root}cart.js`,{headers:{Accept:'application/json'}});
            if (cartResponse.ok) {const cart = await cartResponse.json();document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = cart.item_count);}
          } catch (error) {message.textContent = error.message || strings.error;message.classList.add('is-error');}
          finally {adding=false;add.removeAttribute('aria-busy');selection();}
        });
      }
      product.querySelector('[data-open-size]')?.addEventListener('click',event => {if (sizeDialog?.showModal) {event.preventDefault();sizeDialog.showModal();}});
      product.querySelector('[data-zoom]')?.addEventListener('click',() => zoomDialog?.showModal());
      product.querySelectorAll('dialog').forEach(dialog => {
        dialog.querySelector('[data-close-dialog]')?.addEventListener('click',() => dialog.close());
        dialog.addEventListener('click',event => {if (event.target === dialog) {const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom) dialog.close();}});
      });
    });
  }
  document.querySelector('[data-pause-ribbon]')?.addEventListener('click',event=>{const button=event.currentTarget;const paused=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(paused));button.closest('.cl-ribbon').classList.toggle('is-paused',paused);});
  init();
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('keydown',event => {if(event.key === 'Escape') document.querySelectorAll('.cl-menu[open],.cl-filter[open]').forEach(x=>x.open=false);});
  document.addEventListener('click',event => {document.querySelectorAll('.cl-menu[open],.cl-filter[open]').forEach(x=>{if(!x.contains(event.target))x.open=false;});});
})();
